import { HttpClient, HttpEventType } from "@angular/common/http";
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { TokenService, ConfigService } from "@core";
import { FieldType } from "@ngx-formly/core";

@Component({
  selector: "formly-field-file",
  template: `
  <div class="upload_group">
      <div class="upload_group_button"> 
      <!-- <label  *ngIf="field.templateOptions.label">{{ field.templateOptions.label }}</label> -->
      <div   style="width: 100%; clear: both;" *ngIf="field.templateOptions.showimage && model[fname]">
                                                <img [src]="fileBaseUrl + model[fname]"
                                                     style="width:  100%;" />
                                            </div>
      <div   style="width: 100%; clear: both;" *ngIf="field.templateOptions.showname && model[fname]">
      <a style="  margin-bottom: 10px;   display: block;    width: 100%;" href="{{fileBaseUrl + model[fname]}}" target="_blank">Download</a>
      <span>{{model[fname]}}</span>
      </div>
      <input
              #fileinputval
              [formControl]="formControl"
              [formlyAttributes]="field"
              style="display: none" />
      <input
              #fileinput
               type="file"  
              (change)="onChange($event)"
              style="display: none"  accept="image/*,audio/*,video/*,.pdf,.txt,.zip,.rar,.doc,.docx,.xls,.xlsx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            />
            
        <button type="button" [loading]="loadingUpload" class="mr-2"
                mat-raised-button color="primary" (click)="openFileInput()">
          <mat-icon>attach_file</mat-icon>
        </button>
        <button type="button"  class="mr-2"
                mat-raised-button color="basic" (click)="removeFile()">
          <mat-icon>delete_forever</mat-icon>
        </button>
      </div>
      <div class="upload_group_message"  *ngIf="progress > 0">
        <mtx-progress [value]="progress" [striped]="true" foreground="#169c05" background="#e0e0e0"> {{progress}}%
        </mtx-progress>
      </div>
  </div>
 
  `,
  styleUrls: ["./file-type.component.scss"]
})
export class FormlyFieldFile extends FieldType implements OnInit {
  @ViewChild("fileinput") el: ElementRef;
  @ViewChild("fileinputval") elval: ElementRef;
  selectedFiles: File[];
  progress: number;
  message: string;
  loadingUpload: boolean;
  fname: string;
  apiUrl: any;
  uploadUrl: string;
  fileBaseUrl: string;
  uploadFinished($event) {
    this.model[this.fname] = $event.Url;

    this.elval.nativeElement.value = $event.Url; this.cdr.detectChanges();
    if (this.to.onUploadFinished) {
      this.to.onUploadFinished($event);
    }
  }
  removeFile() {

    this.elval.nativeElement.value = '';
    this.model[this.fname] = null; this.cdr.detectChanges();
  }

  constructor(public sanitizer: DomSanitizer, private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private token: TokenService,
    private config: ConfigService) {
    super();
    var conf = this.config.getConfig();
    this.apiUrl = conf.apiBaseUrl;
    this.fileBaseUrl = conf.fileBaseUrl;
  }
  ngOnInit() {
    this.uploadUrl = this.to.url || 'upload/UploadImage';
    this.loadingUpload = false;
    this.fname = this.key as string;
  }
  openFileInput() {
    this.el.nativeElement.click();
  }
  onDelete(index) {
    // this.formControl.reset();
    console.log(this.selectedFiles);
    this.selectedFiles.splice(index, 1);

    this.formControl.patchValue(this.selectedFiles);
  }
  onChange(event) {
    this.selectedFiles = Array.from(event.target.files);
    let files = this.selectedFiles;
    this.progress = 0;
    this.message = '';
    if (files.length === 0) {
      return;
    }
    this.loadingUpload = true;
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    try {
      this.http.post(`${this.apiUrl + this.uploadUrl}`, formData, {
        headers: {
          'Authorization': `Bearer ${this.token.get().token}`
        },
        reportProgress: true,
        observe: 'events'
      })
        .subscribe(event => {

          if (event.type === HttpEventType.UploadProgress) {
            this.progress = Math.round(100 * event.loaded / event.total);

            if (this.progress >= 100) {
              this.progress = 0;
            }
            this.cdr.detectChanges();
          }

          else if (event.type === HttpEventType.Response) {
            this.message = 'OK';
            this.loadingUpload = false;
            this.uploadFinished(event.body);
          }
          this.el.nativeElement.value = '';
        }, error => {
          this.el.nativeElement.value = '';
          this.loadingUpload = false;
        });
    } catch (error) {
      this.loadingUpload = false;
    }
  }
  getSanitizedImageUrl(file: File) {
    return this.sanitizer.bypassSecurityTrustUrl(
      window.URL.createObjectURL(file)
    );
  }
  isImage(file: File): boolean {
    return /^image\//.test(file.type);
  }
}